module.exports = __webpack_public_path__ + "img/logoCRD.245d9b4.png";